module.exports = __webpack_public_path__ + "static/media/landing_customer_carousel_1.7336f873.svg";